import {
  FETCH_REJECT_FAIL,
  FETCH_REJECT_REQUEST,
  FETCH_REJECT_SUCCESS,
} from "../../ActionType/RejectTypes/RejectType";

export const getRejectReducer = (
  state = { loading: true, rejects: [], total: 0, error: "" },
  action
) => {
  switch (action.type) {
    case FETCH_REJECT_REQUEST:
      return {
        loading: true,
        rejects: [],
        total: 0,
      };
    case FETCH_REJECT_SUCCESS:
      console.log(action.payload.data);
      return {
        loading: false,
        rejects: action.payload.data,
        total: action.payload.total,
        error: "",
      };
    case FETCH_REJECT_FAIL:
      return {
        loading: false,
        rejects: [],
        total: 0,
        error: "",
      };
    default:
      return state;
  }
};
